/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import AddUserContainer from "../../containers/AddUserContainer";
import { useRoles } from "../../queries/user";
import EditUser from "../AddEditUserComponent/EditUser";
import ButtonComponent from "../Widgets/Button";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  StyledUserList,
  StyledGestionUtilisateurs,
  StyledUserRow,
  StyledDivWithIconButton,
} from "./styles";
import DeleteUserContainer from "../../containers/DeleteUserContainer";
import { UserContext } from "../../context/user/UserContext";

const GestionUtilisateursComponent = ({
  isLoadingUsers,
  userList,
  updateUserToUserList,
}) => {
  const [isAddingUser, setIsAddingUserStatus] = useState(false);
  const [usersWithCorrectRole, setUsersWithCorrectRole] = useState(null);
  const [rolesMap, setRoleMap] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalDeleteUser, setIsModalDeleteUser] = useState(false);
  const [userSelected, setUserSelected] = useState(null);

  const { data: roles = [], isLoading } = useRoles();
  const [userContext] = useContext(UserContext);

  useEffect(() => {
    if (roles.length > 0) {
      let tempRoleMap = {};
      roles.forEach((role) => {
        tempRoleMap = {
          ...tempRoleMap,
          [role.id]: role.name,
        };
      });
      setRoleMap(tempRoleMap);
    }
  }, [roles]);

  useEffect(() => {
    if (rolesMap && userList.length > 0) {
      const userWithRole = [];
      userList.forEach((user) => {
        if (user.role) {
          userWithRole.push({
            ...user,
            role: rolesMap[user.role],
            roleID: user.role,
          });
        }
      });
      setUsersWithCorrectRole(userWithRole);
    }
  }, [rolesMap, userList]);

  const handleClickOnUser = (user) => {
    setUserSelected(user);
    setModalOpen(true);
  };

  const handleDeleteUser = (user) => {
    setUserSelected(user);
    setIsModalDeleteUser(true);
  };

  return (
    <StyledGestionUtilisateurs>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <h1>Liste des Utilisateurs</h1>
        <ButtonComponent
          title={"Ajouter un utilisateur"}
          variant="contained"
          disabled={isAddingUser}
          onClickMethod={() => {
            setIsAddingUserStatus(true);
          }}
        />
      </div>
      {isLoading || isLoadingUsers ? (
        <CircularProgress />
      ) : (
        <>
          <StyledUserList>
            {usersWithCorrectRole?.map((user) => (
              <StyledUserRow
                key={user._id}
                onClick={() => {
                  handleClickOnUser(user);
                }}
              >
                <span>{user.username}</span>
                <StyledDivWithIconButton>
                  <span>{user.role}</span>
                  {userContext.profile._id !== user._id && (
                    <IconButton
                      aria-label="delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteUser(user);
                      }}
                    >
                      <DeleteIcon color="error" variant="contained" />
                    </IconButton>
                  )}
                </StyledDivWithIconButton>
              </StyledUserRow>
            ))}
          </StyledUserList>
        </>
      )}
      {isModalOpen && (
        <EditUser
          updateUserToUserList={updateUserToUserList}
          user={userSelected}
          roles={roles}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
        />
      )}
      {isAddingUser && (
        <AddUserContainer
          isAddingUser={isAddingUser}
          setIsAddingUserStatus={setIsAddingUserStatus}
        />
      )}
      {isModalDeleteUser && (
        <DeleteUserContainer
          user={userSelected}
          isModalDeleteUser={isModalDeleteUser}
          setIsModalDeleteUser={setIsModalDeleteUser}
        />
      )}
    </StyledGestionUtilisateurs>
  );
};

export default GestionUtilisateursComponent;
